import { render, staticRenderFns } from "./StationSummaryFrame.vue?vue&type=template&id=0254db0e&scoped=true"
import script from "./StationSummaryFrame.vue?vue&type=script&lang=ts"
export * from "./StationSummaryFrame.vue?vue&type=script&lang=ts"
import style0 from "./StationSummaryFrame.vue?vue&type=style&index=0&id=0254db0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0254db0e",
  null
  
)

export default component.exports